import React, {Component} from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { saveOrder } from '../../../actions/orders'

// import styles
import './otherpricemodal.scss'

// import components
import Modal from '../../components/Modal'
import { formatCurrency2, reverseFormatCurrency2 } from '../../../utils/currency'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import Text from '../../elements/text'
import Textarea from '../../elements/textarea'

class OtherPriceModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      show: false,
      other: {},
      bodyShopPrice: {},
      isLoading: false,
      error: '',
      order: {}
    }
    this.saveOther = this.saveOther.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentWillReceiveProps (props) {
    if (props.show !== this.state.show) {
      this.setState({
        show: props.show,
        other: props.other,
        bodyShopPrice: props.bodyShopPrice,
        order: props.order,
        isLoading: false,
        error: ''
      })
    }
  }

  componentDidMount () {
    if (this.props.show !== this.state.show) {
      this.setState({
        show: this.props.show,
        other: this.props.other,
        order: this.props.order,
        isLoading: false,
        error: ''
      })
    }
  }

  saveOther (e) {
    e.preventDefault()
    let { order, other, bodyShopPrice } = this.state
    this.setState({ isLoading: true, error: '' })

    let data = {
      OrderID: order.Id,
      Other: {
        IsDirty: true,
        OtherTitle: other.Title || null,
        OtherDescription: other.Description || null,
        Price: parseFloat(other.Price),
        Environment: parseFloat(other.Environment)
      }
    }

    if (this.props.department === 1) {
      data.BodyShopPrice = {
        IsDirty: true,
        ManualBodySparePartPrice: parseFloat(bodyShopPrice.ManualBodySparePartPrice),
        ManualBodyMiscPrice: parseFloat(bodyShopPrice.ManualBodyMiscPrice),
        ManualBodyWorkPrice: parseFloat(bodyShopPrice.ManualBodyWorkPrice),
        ManualBodyWorkEnvPrice: parseFloat(bodyShopPrice.ManualBodyWorkEnvPrice)
      }
    }

    this.props.saveOrder(data).then(() => {
      this.props.onClose(false)
    }).catch(() => {
      this.setState({
        isLoading: false,
        error: translation('960')
      })
    })
  }

  onInputChange (e) {
    let val = e.target.value
    let amountFields = ['Price', 'Environment', 'ManualBodySparePartPrice', 'ManualBodyMiscPrice', 'ManualBodyWorkPrice', 'ManualBodyWorkEnvPrice']
    if (amountFields.includes(e.target.name)) {
      val = reverseFormatCurrency2(e.target.value)
    } else {
      val = e.target.value
    }
    if (e.target.name.startsWith('ManualBody')) {
      this.setState({
        bodyShopPrice: {
          ...this.state.bodyShopPrice,
          [e.target.name]: val
        }
      })
    } else {
      this.setState({
        other: {
          ...this.state.other,
          [e.target.name]: val
        }
      })
    }
  }

  price (name) {
    if (name.startsWith('ManualBody')) {
      if (this.state.bodyShopPrice !== undefined && this.state.bodyShopPrice[name] !== undefined) {
        let stateVal = this.state.bodyShopPrice[name]
        if (stateVal === null) stateVal = 0
        let val = formatCurrency2(stateVal, 2)
        return val
      }
    } else if (this.state.other !== undefined && this.state.other[name] !== undefined) {
      let stateVal = this.state.other[name]
      if (stateVal === null) stateVal = 0
      let val = formatCurrency2(stateVal, 2)
      return val
    }
  }

  render () {
    if (this.props.type === 1) {
      if (typeof this.props.other.Title === 'undefined') return null
    }

    let modalTitle = translation('73')
    if (this.props.type !== 1) {
      modalTitle = translation('2096')
    }

    const onBlur = (e) => {
      if (e.target.name.startsWith('ManualBody')) {
        let val = this.state.bodyShopPrice[e.target.name]
        if (val === null) val = 0
        this.refs[e.target.name].value = formatCurrency2(val, 2)
      } else {
        let val = this.state.other[e.target.name]
        if (val === null) val = 0
        this.refs[e.target.name].value = formatCurrency2(val, 2)
      }
    }

    const onFocus = (e) => {
      if (e.target.value === formatCurrency2(0)) {
        e.target.value = ''
      }
    }

    const beforeDiscountLabel = this.props.order.HasDiscount ? ` ${translation('15012')}` : ''

    const renderBodySparePartAmount = () => {
      return (
        <Text labelText={translation('637') + beforeDiscountLabel} name='ManualBodySparePartPrice' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='ManualBodySparePartPrice' defaultValue={this.price('ManualBodySparePartPrice')} />
      )
    }

    const renderBodyMiscAmount = () => {
      return (
        <Text labelText={translation('15154') + beforeDiscountLabel} name='ManualBodyMiscPrice' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='ManualBodyMiscPrice' defaultValue={this.price('ManualBodyMiscPrice')} />
      )
    }

    const renderBodyWorkPriceAmount = () => {
      return (
        <Text labelText={translation('416') + beforeDiscountLabel} name='ManualBodyWorkPrice' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='ManualBodyWorkPrice' defaultValue={this.price('ManualBodyWorkPrice')} />
      )
    }

    const renderBodyWorkEnvPriceAmount = () => {
      return (
        <Text labelText={translation('15156') + beforeDiscountLabel} name='ManualBodyWorkEnvPrice' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='ManualBodyWorkEnvPrice' defaultValue={this.price('ManualBodyWorkEnvPrice')} />
      )
    }

    const renderPaintPriceAmount = () => {
      return (
        <Text labelText={translation('641') + beforeDiscountLabel} name='Price' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='Price' defaultValue={this.price('Price')} />
      )
    }

    const renderPaintEnvironmentAmount = () => {
      return (
        <Text labelText={translation('13339') + beforeDiscountLabel} name='Environment' onChange={this.onInputChange} onFocus={onFocus} onBlur={onBlur} ref='Environment' defaultValue={this.price('Environment')} />
      )
    }

    return (
      <div className='other__modal'>
        <Modal
          {...this.props}
          header={modalTitle}
          bottomBarProps={{
            disabled: this.state.isLoading,
            actionLabelText: translation('791'),
            onActionClick: this.saveOther
          }}
        >
          {this.state.error && <div className='alert alert-danger'>{this.state.error}</div>}

          {this.props.type === 1 && (
            <Text labelText={translation('1206')} name='Title' onChange={this.onInputChange} value={this.state.other.Title || ''} />
          )}

          {this.props.department !== 1 && renderPaintPriceAmount()}
          {this.props.department !== 1 && renderPaintEnvironmentAmount()}

          {this.props.department === 1 && renderBodyWorkPriceAmount()}
          {this.props.department === 1 && renderBodySparePartAmount()}
          {this.props.department === 1 && renderBodyMiscAmount()}
          {this.props.department === 1 && renderBodyWorkEnvPriceAmount()}

          {this.props.type === 1 && (
            <Textarea labelText={translation('1021')} name='Description' onChange={this.onInputChange} value={this.state.other.Description || ''} />
          )}
        </Modal>
      </div>
    )
  }
}

OtherPriceModal.propTypes = {
  saveOrder: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  // saveOrder
})(OtherPriceModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/OtherPriceModal/index.js